module.exports = __webpack_public_path__ + "static/media/sg8cr93.028a5d78.png";